module.exports = __webpack_public_path__ + "static/media/lost.afc9e614.mp3";